import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'mappingCategoryInput',
    'mappingInput',
    'mappingInputWrapper',
  ]

  static values = {
    disableInputsCategory: String,
    mappingCategory: String,
  }

  connect() {
    this.handleCategoryChange()
  }

  handleCategoryChange() {
    this.mappingCategoryValue = this.mappingCategoryInputTarget.value
  }

  mappingCategoryValueChanged(value) {
    this.mappingInputTargets.forEach((input) => {
      input.disabled = (this.disableInputsCategoryValue === value)
    })

    this.mappingInputWrapperTargets.forEach((input) => {
      input.dataset.mappingCategory = value
    })
  }
}
